import { useState } from 'react';
import { Button, cn, Typography, useTranslate } from '@prenuvo/halo';

import { SidePanel } from '@/shared/ui';

import { PatientDocs } from './patient-docs';
import { PatientDocument } from './patient-docs-side-panel.model';
import { PatientDocsSidePanelTitle } from './patient-docs-side-panel-title.component';

interface PatientDocsSidePanelProps {
  isOpen: boolean;
  onOpenChange: (value: boolean) => void;
}

export function PatientDocsSidePanel({ isOpen, onOpenChange }: PatientDocsSidePanelProps) {
  const [patientDocument, setPatientDocument] = useState<PatientDocument>();
  const translate = useTranslate();

  const handleClose = () => {
    setPatientDocument(undefined);
    onOpenChange(false);
  };

  const handleToggleSidePanel = () => (isOpen ? handleClose() : onOpenChange(true));

  return (
    <div>
      <Button
        className={{
          root: cn({
            'bg-stone-200 text-stone-950 hover:border-stone-200 hover:bg-stone-200 hover:text-stone-950 dark:bg-stone-200 dark:text-stone-950 hover:dark:border-stone-200 hover:dark:bg-stone-200 hover:dark:text-stone-950':
              isOpen,
          }),
        }}
        data-testid="patient-documents-button"
        onClick={handleToggleSidePanel}
        size="sm"
        translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.BUTTON"
        translationValue={{
          content: (
            <Typography
              className={cn({
                'dark:text-stone-950': isOpen,
              })}
              translationKey="FCT.PATIENT_DOCS.SIDE_PANEL.PT_DOCS"
              variant="button-sm"
            />
          ),
        }}
        variant="text"
      />

      <SidePanel
        ariaLabel={translate('FCT.PATIENT_DOCS.SIDE_PANEL.TITLE') as string}
        isOpen={isOpen}
        onClose={handleClose}
        title={
          <PatientDocsSidePanelTitle
            onBackClick={() => setPatientDocument(undefined)}
            patientDocument={patientDocument}
          />
        }
        titleJustification="between"
      >
        {isOpen && (
          <PatientDocs
            onUpdateSidePanelPatientDoc={setPatientDocument}
            patientDocument={patientDocument}
          />
        )}
      </SidePanel>
    </div>
  );
}
